module.exports = __webpack_public_path__ + "static/media/rotate-icon.84aa1a4a.svg";